import { type SVGProps } from "react";

export function CalendarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.333 2.5V5.83333M6.66634 2.5V5.83333M3.33301 9.16667H16.6663M3.33301 5.83333C3.33301 5.39131 3.5086 4.96738 3.82116 4.65482C4.13372 4.34226 4.55765 4.16667 4.99967 4.16667H14.9997C15.4417 4.16667 15.8656 4.34226 16.1782 4.65482C16.4907 4.96738 16.6663 5.39131 16.6663 5.83333V15.8333C16.6663 16.2754 16.4907 16.6993 16.1782 17.0118C15.8656 17.3244 15.4417 17.5 14.9997 17.5H4.99967C4.55765 17.5 4.13372 17.3244 3.82116 17.0118C3.5086 16.6993 3.33301 16.2754 3.33301 15.8333V5.83333ZM6.66634 12.5H8.33301V14.1667H6.66634V12.5Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CalendarCheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.832 17.5H4.9987C4.55667 17.5 4.13275 17.3244 3.82019 17.0118C3.50763 16.6993 3.33203 16.2754 3.33203 15.8333V5.83333C3.33203 5.39131 3.50763 4.96738 3.82019 4.65482C4.13275 4.34226 4.55667 4.16667 4.9987 4.16667H14.9987C15.4407 4.16667 15.8646 4.34226 16.1772 4.65482C16.4898 4.96738 16.6654 5.39131 16.6654 5.83333V11.25M13.332 2.5V5.83333M6.66536 2.5V5.83333M3.33203 9.16667H16.6654M12.4987 15.8333L14.1654 17.5L17.4987 13.3333M6.66536 12.5H8.33203V14.1667H6.66536V12.5Z"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CalendarXIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.832 17.5H4.9987C4.55667 17.5 4.13275 17.3244 3.82019 17.0118C3.50763 16.6993 3.33203 16.2754 3.33203 15.8333V5.83333C3.33203 5.39131 3.50763 4.96738 3.82019 4.65482C4.13275 4.34226 4.55667 4.16667 4.9987 4.16667H14.9987C15.4407 4.16667 15.8646 4.34226 16.1772 4.65482C16.4898 4.96738 16.6654 5.39131 16.6654 5.83333V11.25M13.332 2.5V5.83333M6.66536 2.5V5.83333M3.33203 9.16667H16.6654M18.332 18.3333L14.1654 14.1667M14.1654 18.3333L18.332 14.1667M6.66536 12.5H8.33203V14.1667H6.66536V12.5Z"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
